import { pxToRem } from "@ui/lib/utils";

export function AnimatedStaticLogo() {
  return (
    <svg viewBox='0 0 116 15' fill='currentColor' aria-hidden style={{ width: pxToRem(116) }}>
      <path d='M3.069 0H0v14.752h3.069z' className='animate-fade-in-scale-y' />
      <path d='M9.165 0H6.097l.001 14.752h3.067z' className='animate-fade-in-scale-y' />

      <path
        d='M21.275 0h-9.083v14.753h9.083v-2.46h-6.014V8.43h5.602V5.97h-5.602V2.459h6.014z'
        className='animate-fade-in-width delay-0'
      />
      <path d='M26.053 0H23.15v14.752h2.903z' className='animate-fade-in-width delay-1' />
      <path
        d='M32.911 3.45c3.109 0 4.882 1.715 4.882 5.806v.661h-7.126c.102 2.397.823 3.203 2.203 3.203 1.092 0 1.772-.64 1.895-1.757h2.904C37.484 13.801 35.466 15 32.87 15c-3.295 0-5.066-1.756-5.066-5.785 0-4.03 1.998-5.765 5.107-5.765m-.04 1.86c-1.216 0-1.978.682-2.184 2.686h4.243c-.144-2.025-.844-2.685-2.06-2.685'
        className='animate-fade-in-width delay-2'
      />
      <path
        d='M38.411 3.7h2.966l2.184 8.326 2.244-8.327h2.966l-3.584 11.054h-3.192z'
        className='animate-fade-in-width delay-3'
      />
      <path
        d='M54.435 3.45c3.11 0 4.881 1.715 4.881 5.806v.661H52.19c.103 2.397.824 3.203 2.204 3.203 1.09 0 1.771-.64 1.895-1.757h2.904C59.007 13.801 56.99 15 54.393 15c-3.295 0-5.066-1.756-5.066-5.785 0-4.03 1.998-5.765 5.108-5.765m-.042 1.86c-1.214 0-1.977.682-2.182 2.686h4.242c-.144-2.025-.844-2.685-2.06-2.685'
        className='animate-fade-in-width delay-4'
      />
      <path
        d='M66.112 5.558c-1.277 0-2.1.95-2.1 2.686v6.508h-2.946V3.698h2.946v1.426c.515-.951 1.688-1.674 3.11-1.674 2.1 0 3.542 1.178 3.542 3.74v7.562H67.76V7.644c0-1.426-.598-2.086-1.648-2.086'
        className='animate-fade-in-width delay-5'
      />
      <path d='M76.143 0h-3.07v14.753h8.836v-2.46h-5.766z' className='animate-fade-in-width delay-6' />
      <path
        d='M87.058 3.45c1.235 0 2.368.703 2.822 1.446V3.698h2.966v11.054h-2.884V13.45c-.432.868-1.648 1.55-2.986 1.55-2.637 0-4.346-1.694-4.346-5.785 0-4.215 1.936-5.765 4.428-5.765m.762 2.17c-1.442 0-2.265 1.095-2.265 3.595s.823 3.615 2.265 3.615 2.224-1.115 2.224-3.615-.782-3.595-2.224-3.595'
        className='animate-fade-in-width delay-7'
      />
      <path
        d='M97.995 0v4.897c.494-.765 1.647-1.447 2.883-1.447 2.431 0 4.367 1.55 4.367 5.765S103.35 15 100.816 15c-1.338 0-2.43-.682-2.842-1.55v1.302H95.09V0zm2.059 5.64c-1.441 0-2.224 1.075-2.224 3.575s.783 3.616 2.224 3.616 2.266-1.116 2.266-3.616-.824-3.575-2.266-3.575'
        className='animate-fade-in-width delay-8'
      />
      <path
        d='M109.344 11.467h-2.904c.062 2.438 1.669 3.533 4.573 3.533 2.677 0 4.654-1.322 4.654-3.554s-1.503-2.83-3.892-3.43l-.906-.227c-.866-.207-1.36-.496-1.36-1.261 0-.826.618-1.26 1.504-1.26.885 0 1.503.434 1.565 1.447h2.904c-.082-2.294-1.957-3.265-4.428-3.265s-4.408 1.322-4.408 3.409 1.257 2.769 3.769 3.409l.886.228c1.03.248 1.504.537 1.504 1.322 0 .868-.618 1.364-1.71 1.364s-1.709-.558-1.751-1.715'
        className='animate-fade-in-width delay-9'
      />
    </svg>
  );
}
